const PREFIX = "overpay:";

export type OverpaySession = {
  payment_id?: string;
  tracking_id?: string;
  amount?: number;
  sign_id?: string;
};

// Payment providers open in a new tab on desktop, so sessionStorage would not
// be visible on the return URL. localStorage keeps the pending payment id
// available long enough for the SPA to call the backend complete endpoint.
const storage = () => window.localStorage;

export const saveOverpaySession = (key: string, value: OverpaySession) => {
  storage().setItem(`${PREFIX}${key}`, JSON.stringify(value));
};

export const getOverpaySession = (key: string): OverpaySession | null => {
  const raw = storage().getItem(`${PREFIX}${key}`);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (_error) {
    return null;
  }
};

export const clearOverpaySession = (key: string) => {
  storage().removeItem(`${PREFIX}${key}`);
};
